import React from 'react';
import styled from 'styled-components';
import classnames from 'classnames';

import { Input } from '@/components/shared/Input';
import { Label } from '@/components/shared/Label';

type Props = {
  value?: string;
  onChange: (value: string | null) => void;
  error?: string;
};

export const BillingNote: React.FC<Props> = ({ value, error, onChange }) => {
  return (
    <Styled>
      <div id="billingNote" className={classnames('field', { error })}>
        <Input
          className={classnames('billing-note', { 'is-error': error })}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
        />
        {error && <Label>{error}</Label>}
      </div>
    </Styled>
  );
};

const Styled = styled.div`
  #billingNote {
    font-weight: 400;
    font-style: normal;
    display: flex;
    flex-direction: column;
    color: rgba(0, 0, 0, 0.87);
  }
  .billing-note {
    margin-top: 7px;
    margin-bottom: 40px;
  }
`;
